module.exports = __webpack_public_path__ + "img/UAE.5830d354.png";